import script from "./DocumentListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentListItem.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentListItem.vue?vue&type=style&index=0&id=8b0023d6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b0023d6"]])

export default __exports__